import { InputBaseComponentProps, InputBaseProps } from '@mui/material';
import React from 'react';

import { phoneMaskSpec } from '../../utils/helpers';
import { MaskedInput } from '../MaskedInput/MaskedInput';
import { TextField, TextFieldProps } from '../TextField/TextField';

export const MaskedPhoneInput = (props: InputBaseComponentProps & { ref?: InputBaseProps['ref'] }) => {
  const { ref, ...inputProps } = props;

  return (
    <MaskedInput
      inputProps={inputProps}
      ref={ref}
      maskProps={{
        ...phoneMaskSpec,
        unmask: true, // When using MaskedPhoneInput as a custom inputComponent, always unmask amd return "raw" value
        overwrite: true
      }}
    />
  );
};

interface PhoneNumberTextFieldProps extends Omit<TextFieldProps, 'slotProps'> {}

export const PhoneNumberTextField = (props: PhoneNumberTextFieldProps) => {
  return (
    <TextField
      slotProps={{
        input: {
          inputComponent: MaskedPhoneInput
        }
      }}
      {...props}
    />
  );
};
